import { gql } from 'apollo-angular'

import { USER_LIST_FIELDS } from '../../fragments/user.fragment'

export const GET_USERS_BY_ORGANIZATION = gql`
  query getUsers($organizationId: JSON!, $page: Int!, $itemsPerPage: Int!) {
    Users(
      page: $page
      limit: $itemsPerPage
      where: { organization: { equals: $organizationId } }
    ) {
      docs {
        ...UserListFields
      }
      totalDocs
    }
  }
  ${USER_LIST_FIELDS}
`
